<template>
    <div style="overflow-x: hidden;">
      <div class="scroll-container">
<!-- 第一部分开始 -->
        <div class="banner-1">
           <img src="../../../assets/banneruserservice.png" alt="">
           <div class="productread">
            <div class="productread-itme">
              <div class="productread-itme-title">产品使用说明集合</div>

              <div class="productread-itme-content">
                 <!-- 第一项 -->

                <div class="productread-itme-content-itme1" :style="{ 
                  backgroundImage: 'url(' + items[0].bg + ')',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }"
                @click="goLink(items[0].link)">
                  <div class="productread-itme-content-itme1-title">{{ items[0].title }}</div> 
                    <div class="productread-itme-content-itme1-img" ><img src="../../../assets/jiantouuservice 1.png" alt=""></div>
              </div>
          <!-- 第二项 -->
                <div class="productread-itme-content-itme2" :style="{ 
                  backgroundImage: 'url(' + items[1].bg + ')',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }"
                @click="goLink(items[1].link)">
                <div class="productread-itme-content-itme1-title2">{{ items[1].title }}</div> 
                <div class="productread-itme-content-itme1-img" ><img src="../../../assets/jiantouuservice 1.png" alt=""></div>
              </div>

              </div>

            </div>
           </div>
        </div>
<!-- 第一部分结束 -->

<!-- 第二部分开始 -->
        <div style="margin-top: 2vh;"> 
          
          <div class="puk-container">
              <!-- 第一张卡片开始 -->
          <div
           v-for="(item, index) in cardList" 
                    :key="index"
          class="puk-card" :style="{ 
            backgroundImage: `url(${item.bgImage})` 
          }">
              <div class="puk-text">
                <h3>{{ item.title }}</h3>
                <p>{{ item.description }}</p>
              </div>
              <button class="puk-btn" @click="goLink(item.link)">立即查看</button>
          </div>
        <!-- 第一张卡片结束 -->

        </div>

        </div>
    <!-- 第二部分结束-->

    <!-- 第三部分开始 -->
     <div class="servicepukiservice">
    <div class="service-section">
      <h2 class="service-title">更多服务</h2>
      <div class="service-grid">
          <div 
              v-for="(item, index) in services" 
              :key="index"
              class="service-item"
              @click="handleServiceClick(item)"
          >
              <img :src="item.icon" :alt="item.name" class="service-icon">
              <span class="service-name">{{ item.name }}</span>
          </div>
      </div>
  </div>
</div>
  <!-- 第三部分结束 -->

  <!-- 第四部分开始 -->

  <van-popup
  v-model="showPicker"
  position="bottom"
  :overlay="true"
  class="popup-picker"
>
<van-picker
    title="请选择语言"
    show-toolbar
    :columns="columns"
    :default-index="0"
    @confirm="onConfirm"
    @cancel="onCancel"
    @change="onChange"
   
/>
</van-popup>

<div class="bottom2" style="position:relative;margin-top:3vh;">
<img style="width:100vw;height:auto;" src="@/assets/bottom2.png"></img>

<div class="bottom2-span">

<div class="bottom2-span-one">
<ul class="">
<li>{{bottomh5.icpshort}}</li>
<li>{{bottomh5.icplong}}</li>
</ul>
</div>

<div class="bottom2-span-toow">
<ul class="">
<li @click="tolicece(bottomh5.licence.link)">{{bottomh5.licence.licencetext}}</li>
<li @click="showPicker = true">选择语言</li>
</ul>
</div>

</div>

</div>
  <!-- 第四部分结束 -->

  <div style="height: 2px;width:500px"></div>
</div>
    
        <div style="width: 100vw;">
            <bottomh5></bottomh5>
          </div>
    </div>
</template>
<script>
 import bottomh5 from'@/view/h5/public/bottomh5.vue'
 import axios from 'axios';
 import apiUrls from '@/http/http';
 export default {
    components:{
          bottomh5
        },
        data() {
          return {
 // 每一项包含背景图片和标题
 items: [
        {
          title: '铝镁合金商旅箱说明书',
          // 使用 require() 来引入图片，确保路径正确
          bg: require('@/assets/p01uservice.png'),
          link:'https://baidu.com'
        },
        {
          title: 'PC商旅箱说明书',
          bg: require('@/assets/u01userservice.png'),
          link:'https://baidu.com'
        }
      ],
           
               cardList: [
               {
                   title: 'PUK谱褀产品',
                   description: '售后/保修服务说明',
                   bgImage: require('@/assets/pukiservicecontserver.png'),
                   buttonText: '立即查看',
                   link:'https://baidu.com'
               },
               {
                   title: '品牌联名',
                   description: '探索多元合作',
                   bgImage: require('@/assets/service-ssss.png'),
                   buttonText: '立即查看',
                   link:'https://baidu.com'
               }
           ],
           services: [
               {
                   name: '联络客服',
                   icon:  require('@/assets/pic-icon-17-17service.png'),
                   link: '#'
               },
               {
                   name: '商业合作',
                   icon: require('@/assets/pic-icon-17-17service2.png'),
                   link: '#'
               },
               {
                   name: '营销网络',
                   icon: require('@/assets/pic-icon-17-17service3.png'),
                   link: '#'
               }
           ],
           columns: ['中文', '英文'],
        columnsen: ['CN', 'EN'],
        showPicker: false, // 控制弹出层的显示与隐藏
        bottomh5:{
          icpshort:'京ICP备19000000号',
          icplong:'公安备案号11010502030000',
          licence:{link:'https://baidu.com',licencetext:'营业执照'}
      },
            
              }
       },
       methods:{

        /*第一部分调整方法*/
         // 动态跳转方法，打开新窗口或跳转到指定链接
            goLink(url) {
              // 如果想在当前窗口跳转可以用 window.location.href = url;
              // 这里示例用新窗口打开
              window.open(url, '_blank');
            },



        onConfirm(value, index) {
    // alert(`当前值：${value}, 当前索引：${index}`);
    
    // 确保使用 this.$route.name 获取当前路由名称
    if (value === '英文' && this.$route.name !== 'indexmainh5en') {
        this.$router.push({ name: 'indexmainh5en' }); // 使用命名路由
    }else if(value === '中文' && this.$route.name !== 'indexmainh5'){
      this.$router.push({ name: 'indexmainh5' }); // 使用命名路由
    }
    
    this.showPicker = false; // 确认后关闭弹出层
},
      onChange(picker, value, index) {
        // console.log('onChange:', picker, value, index);
      },
      onCancel() {
        this.showPicker = false; // 取消后关闭弹出层
      },
       }
 }
</script>

<style scoped>
/deep/.el-menu{
    padding-left: 3.5vw;
  }
  .scroll-container {
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch; /* 支持iOS惯性滚动 */
    scroll-behavior: smooth; /* 平滑滚动效果 */
    overflow-x: hidden;
  }
 /*第一部分----------------------------------------------------------------*/
  .banner-1{
    position: relative;
    width: 100vw;
    height: 30vh;
  }
  .banner-1 img{
    
    width: 100vw;
    height: auto;
    z-index: -1;
  }
  .banner-1 .productread{
    position: absolute;
     height: 16.5vh;
      width:100vw;
      
       top:13.5vh;

       display: flex;
       justify-content: center; /* 水平居中 */
  }
  .banner-1 .productread .productread-itme{
   
      background-color: #FFFFFF;
      height: 100%;
      width: 82vw;

      border-radius: 6px; /* 统一设置四个角为10px圆角 */
      box-shadow: 5px 2px 10px rgba(0,0,0,0.3);  /* 参数说明：水平偏移、垂直偏移、模糊距离、颜色 */

      display: flex;
      flex-direction: column;
      align-items: center;
  }
  .banner-1 .productread .productread-itme .productread-itme-title{
      width: 90%;
      height: 30%;
      

      display: flex;
      align-items: center;/*水平居中*/
      font-size: 0.7rem;
      font-weight: bold;
      color: rgb(71, 70, 70);
  }
  .banner-1 .productread .productread-itme .productread-itme-content{
    width: 90%;
    height: 70%;
   

    display: flex;
    justify-content: space-between; /* 两端对齐 */
}
.banner-1 .productread .productread-itme .productread-itme-content .productread-itme-content-itme1{
    width: 47%;
    height: 80%;
   
    border-radius: 6px; /* 统一设置四个角为10px圆角 */
    box-shadow: 5px 2px 10px rgba(158, 155, 155, 0.3);  /* 参数说明：水平偏移、垂直偏移、模糊距离、颜色 */

   
   
}
.banner-1 .productread .productread-itme .productread-itme-content .productread-itme-content-itme1-title{
  margin-left: 2vw;
  margin-top: 1vh;

  width: 60%;
  font-size: 0.7rem;
  font-weight: bold;
  color: rgb(244, 240, 240);
}
.banner-1 .productread .productread-itme .productread-itme-content .productread-itme-content-itme1-title2{
  margin-left: 2vw;
  margin-top: 1vh;

  width: 40%;
  font-size: 0.7rem;
  font-weight: bold;
  color: rgb(244, 240, 240);
}

.productread-itme-content-itme1-img{
  margin-left: 2vw;
  margin-top: 0.5vh;
  background-color: rgba(244, 240, 240, 0.5);;
  width: 3vw;       /* 正方形边长 */
  height: 1.5vh;
  

  border-radius: 4px; /* 可选圆角 */
}
 
.productread-itme-content-itme1-img img{
  width: 40%;        /* 按比例缩放图标 */
  height: 40%;
  filter: brightness(0) invert(1); /* 自动反白图标颜色 */ 
  margin-bottom: 70%;
  margin-left: 30%;
}

.banner-1 .productread .productread-itme .productread-itme-content .productread-itme-content-itme2{
  width: 47%;
  height: 80%;
  background: bisque;
  border-radius: 6px; /* 统一设置四个角为10px圆角 */
  box-shadow: 5px 2px 10px rgba(158, 155, 155, 0.3);  /* 参数说明：水平偏移、垂直偏移、模糊距离、颜色 */
}
/*第一部分结束----------------------------------------------------------------*/
/*第二部分开始----------------------------------------------------------------*/
.puk-container {
 width: 82vw;
  max-width: 600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.puk-card {
 margin-top: 1vh;
  background-size: cover;
  border-radius: 5px;
  padding: 24px;
  color: white;
  position: relative;
  min-height: 14vh;

  display: flex;
  justify-content: space-between;

  
}
.puk-text{
  margin-top: -2vh;
}

.puk-text h3 {
  font-size: 1rem;
  margin-bottom: -15px;
  color: white;
  font-weight: 400;
}

.puk-text p {
  font-size: 1rem;
  font-weight: 400;
  color: white;
}

.puk-icon {
  width: 24px;
  height: 24px;
  filter: brightness(0) invert(1);
}

.puk-btn {
  position: absolute;
  bottom: 24px;
  left: 24px;
  padding: 3px 12px;
  background: #fff;
  border: 3px solid #ccc;;
  border-radius: 50px;
  color: rgb(159, 155, 155);
  font-size: 0.8rem;
  cursor: pointer;
}

.puk-btn:hover {
  background: rgb(248, 246, 246);
} 

/*第二部分结束----------------------------------------------------------------*/

/*第三部分开始----------------------------------------------------------------*/

.servicepukiservice{
  margin-top: 3vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  
  
}

.service-section {
  border-radius: 6px; /* 统一设置四个角为10px圆角 */
  box-shadow: 3px 3px 3px rgba(213, 213, 213, 0.3);  /* 参数说明：水平偏移、垂直偏移、模糊距离、颜色 */
  padding: 20px;
  background: #fff;
  border-radius: 5px;
  width: 72vw;
  padding-top: 0.5vh;
}

.service-title {
  font-size: 1rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
  height: 2vh;
}

.service-grid {
  display: flex;
  justify-content: space-between;
  gap: 25px;
}

.service-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.service-icon {
  width: 20vw;
  height: 10vh;  
 
}

.service-name {
  margin-top: 1vh;
  font-size: 14px;
  color: #333;
}
/*第三部分结束----------------------------------------------------------------*/


/* 尾部开始 */
.bottom2-span{
  position:absolute;
  top:12vh;
  

  width:100vw;
  display: flex;
  justify-content: space-between;
  gap:1px;
  font-size:0.6rem;
  color:white;
}
.bottom2-span .bottom2-span-one,
.bottom2-span .bottom2-span-toow{
  width:50%;
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items: center; /* 确保所有 li 起始位置一致 */
}
.bottom2-span ul li{
 
}
  /* 尾部结束 */
</style>